module.exports = __webpack_public_path__ + "img/instagram.5b23a837.svg";